'use client';

import Loading from '@/app/[locale]/loading';
import { AssetGrid } from '@/layouts/AssetGrid';
import { CategoryGrid } from '@/layouts/CategoryGrid';
import { useWatchlist } from '@vimond/features/watchlist';

export const Watchlist = ({ title }: { title: string }) => {
  const { assets, categories, isLoading } = useWatchlist();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      <CategoryGrid title={title} categories={categories} />
      <AssetGrid assets={assets} />
    </>
  );
};
